import { ReportContent, STARTER_TEMPLATES, type TemplateDoc } from '@quickreport/domain';

const cbc = STARTER_TEMPLATES.cbc as TemplateDoc;
const rowId = (code: string) =>
  cbc.rows.find((r) => r.kind === 'test' && r.code === code)?.id as string;

/**
 * A believable sample report, so a lab sees its own name, logo and signatures on a real-looking
 * page. Used by the settings preview in the lab app and in the administrator console.
 */
export function sampleReportContent(signatoryIds: string[]): ReportContent {
  const now = Date.now();
  return ReportContent.parse({
    patient: {
      salutation: 'Mr',
      name: 'ABC Zee',
      sex: 'M',
      ageText: '36 Y',
      ageDays: 13149,
      externalId: 'SAMPLE/0001',
    },
    visit: {
      visitNo: 'V-0001',
      referredBy: 'Dr. XYZ',
      sampleType: 'EDTA whole blood',
      collectedAt: new Date(now - 3 * 3600_000).toISOString(),
      receivedAt: new Date(now - 2.9 * 3600_000).toISOString(),
    },
    sections: [
      {
        doc: cbc,
        values: {
          [rowId('HB')]: '13.6',
          [rowId('RBC')]: '4.91',
          [rowId('PCV')]: '41.9',
          [rowId('PLT')]: '113',
          [rowId('TLC')]: '4.67',
          [rowId('NEUT')]: '53',
          [rowId('LYMPH')]: '35.7',
          [rowId('EOS')]: '3.6',
          [rowId('MONO')]: '7.5',
          [rowId('BASO')]: '0.2',
        },
        signedBy: signatoryIds[0],
      },
    ],
  });
}
